import { registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideEnvironmentInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { InitService } from '@infodata-group/inf-commons';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import {
  commonsInterceptors,
  commonsProviders,
  commonsProvidersFrom,
} from './config/commons.config';

registerLocaleData(localeFr, 'fr');
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(
      withXhr(),
      withInterceptors(commonsInterceptors),
      withInterceptorsFromDi(),
    ),
    importProvidersFrom(...commonsProvidersFrom),
    provideEnvironmentInitializer(() =>
      inject(InitService).init(environment.env),
    ),
    { provide: LOCALE_ID, useValue: 'fr' },
    commonsProviders,
  ],
};
